import React, { useRef, useEffect, useState } from 'react';

import './index.module.less';

import Filter from '@helpers/Filter';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import FridayService from '@services/friday';

import NavBar from '@components/NavBar';
import Toast from '@widgets/Toast';
import Alert from '@widgets/Alert';

import { applyCode, applyStatusName } from './constant';

const ApplyDetail = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [info, setInfo] = useState(null);
  const [status, setStatus] = useState(0);

  const getDetail = async () => {
    FridayService.addEvent('application_binding_approval_application_show');
    const { data } = await Http.post(Api.GetApplyInfo, { applyUid: params.current.applyId });
    if(data) {
      setInfo(data);
      if(data?.approvalResult === applyCode.applying) {
        const ts = Date.now() - data?.applyTime; //申请时间距离当前时间差
        if(ts >= 72 * 60 * 60 * 1000) {// 超过三天时显示已过期
          return setStatus(applyCode.expired);
        }
      }
      setStatus(data?.approvalResult);
    }else {
      return Alert.show({
        title: '暂未查询到该申请内容'
      })
    }
  }

  const handleReject = async () => {
    await Http.post(Api.PutApplyResult, { applyUid: params.current.applyId, approvalResult: applyCode.reject });
    setStatus(applyCode.reject);
    Toast.show({
      type: 'strip',
      title: '申请已驳回'
    });
    FridayService.addEvent('application_binding_approve_application_reject_click');

  }

  const handlePass = async () => {
    const { data: count } = await Http.post(Api.GetParentStudentList, { studentUid: info.applyContent.studentUid });
    if(count >= 10) { //目前统一限制为10个
      return Toast.show({
        type: 'strip',
        title: '该设备绑定人数已达上限'
      })
    }
    await Http.post(Api.PutApplyResult, { applyUid: params.current.applyId, approvalResult: applyCode.passed });
    setStatus(applyCode.passed);
    Toast.show({
      type: 'strip',
      title: '申请已通过'
    });
    FridayService.addEvent('application_binding_approval_application_agree_click');

  }

  useEffect(() => {
    getDetail();
    // eslint-disable-next-line
  }, [])

  if(!info) {
    return null;
  }
  return (
    <div
      className="flex container"
      styleName="container"
      style={{ width: '100%', height: document.body.clientHeight }}
    >
      <NavBar title="绑定申请" />
      <div className="flex" styleName="header">
        <div styleName="header-title">
          { (info?.applicantName || '') + '  ' + ((info?.applicantPhone || '').slice(0, 3)  + '****' + (info?.applicantPhone || '').slice(-4))+ `申请绑定${info?.applyContent?.studentName || ''}的学生证` }
        </div>
        <div styleName="desc">{ info?.applyTime ? Filter.date(info.applyTime, 'time') : '' }</div>
      </div>
      <div className="flex" styleName="content">
        <div styleName="content-title">绑定成功后将获得的以下权限</div>
        <div className="flex" styleName="desc"><span styleName="dot"/>与孩子通话</div>
        <div className="flex" styleName="desc"><span styleName="dot"/>与孩子聊天</div>
        <div className="flex" styleName="desc"><span styleName="dot"/>实时查看孩子定位</div>
        <div className="flex" styleName="desc"><span styleName="dot"/>设置学生证通话号码</div>
      </div>
      <div styleName="bottom">
        {
          status === applyCode.applying ? (
            <div
              className="flex"
              styleName="btns"
            >
              <div className="flex flex-center" styleName="btn-reject" onClick={ handleReject }>拒绝</div>
              <div className="flex flex-center" styleName="btn-pass" onClick={ handlePass }>同意</div>
            </div>
          ) : (
            <div className="flex flex-center" styleName="btn-disabled">{ status ? applyStatusName[status] : '' }</div>
          )
        }
      </div>
    </div>
  );
}

export default ApplyDetail;